import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './plugin-rule-name.css';
export function PluginRuleName(props) {
    var _a, _b, _c, _d;
    const { rule, withType } = props;
    const pluginName = (_c = (_b = (_a = rule.singlePluginTypeRule) === null || _a === void 0 ? void 0 : _a.pluginDefinition) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_d = rule.singlePluginTypeRule) === null || _d === void 0 ? void 0 : _d.pluginDefinition.id;
    const pluginSuffix = getSuffix(rule);
    return (_jsxs("span", { className: styles.wrapper, children: [pluginName !== null && pluginName !== void 0 ? pluginName : 'Specific plugin', pluginName && withType && pluginSuffix && (_jsx("span", { title: pluginSuffix, className: styles.suffix, children: pluginSuffix }))] }));
}
function getSuffix(rule) {
    var _a, _b, _c, _d, _e, _f;
    switch ((_a = rule.singlePluginTypeRule) === null || _a === void 0 ? void 0 : _a.type) {
        case 'bundled':
            return 'Bundled';
        case 'marketplace':
        case 'internal-repo': {
            if (((_b = rule.singlePluginTypeRule.version) === null || _b === void 0 ? void 0 : _b.type) === 'all') {
                return 'All Versions';
            }
            if (((_c = rule.singlePluginTypeRule.version) === null || _c === void 0 ? void 0 : _c.type) === 'latest') {
                return 'Latest';
            }
            if (((_d = rule.singlePluginTypeRule.version) === null || _d === void 0 ? void 0 : _d.type) === 'specific') {
                return rule.singlePluginTypeRule.version.version.name;
            }
            if (((_e = rule.singlePluginTypeRule.version) === null || _e === void 0 ? void 0 : _e.type) === 'custom') {
                return rule.singlePluginTypeRule.version.version;
            }
            if (rule.singlePluginTypeRule.type === 'internal-repo') {
                return (_f = rule.singlePluginTypeRule.channel) === null || _f === void 0 ? void 0 : _f.name;
            }
            return undefined;
        }
        default:
            return undefined;
    }
}
